import { css } from '@emotion/react';
import { CSSInterpolation } from '@emotion/serialize';
import { ReactElement, RefObject, useEffect } from 'react';

import { useUIState } from '../../../../app/App';
import { TOOLTIP_HALF_RHOMBUS } from '.';

type Interface = {
	children: string;
	className?: string;
	tooltipRef: RefObject<HTMLDivElement>;
	styles: CSSInterpolation;
	fieldRef?: RefObject<HTMLDivElement>;
	tooltipPosition: 'top' | 'bottom';
	setTooltipPosition: React.Dispatch<React.SetStateAction<'top' | 'bottom'>>;
};

const getHalfHypotenuseSquare = (cat: number): number => Math.sqrt(cat * cat + cat * cat) / 2;

export const GluedTooltip = ({
	className,
	children,
	fieldRef,
	styles,
	tooltipRef,
	tooltipPosition,
	setTooltipPosition,
}: Interface): ReactElement => {
	const { scrollStore } = useUIState();
	useEffect(() => {
		const tooltip = tooltipRef?.current;
		const field = fieldRef?.current;
		const prechatWrapper = scrollStore.prechatScroll?.container;

		if (tooltip && field && prechatWrapper) {
			const tooltipHeight =
				tooltip.getBoundingClientRect().height + +getHalfHypotenuseSquare(TOOLTIP_HALF_RHOMBUS).toFixed(2);
			const tooltipTop = field.getBoundingClientRect().top - tooltipHeight;
			const prechatWrapperTop = prechatWrapper.getBoundingClientRect().top;
			if (tooltipTop - prechatWrapperTop < 0) {
				setTooltipPosition('bottom');
			} else {
				setTooltipPosition('top');
			}
		}
	}, [tooltipRef, fieldRef, scrollStore.prechatScroll?.container, setTooltipPosition]);

	return (
		<div
			ref={tooltipRef}
			className={className}
			css={css`
				div& {
					${styles}
				}
				&::after {
					top: ${tooltipPosition === 'bottom' ? '-5px' : 'initnial'};
					bottom: ${tooltipPosition === 'bottom' ? 'initnial' : '-5px'};
				}
			`}
		>
			{children}
		</div>
	);
};
